var r, t;
function a() {
  if (t) return r;
  t = 1;
  return r = class {
    constructor(r, t = {
      "Content-Type": "application/json; charset=utf-8"
    }) {
      this.baseUrl = "", this.baseUrlParam = "", this.payload = r, this.headers = t, this.parameters = {};
    }
  };
}
export { a as __require };